export default "__VITE_ASSET__358eaca6__"